// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__MgLLy","rootCenter":"LoadMoreObserver_rootCenter__B2dhL","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__GiJ-X"};